import React from 'react';
import { clsx } from 'clsx';

interface LoadingSpinnerProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  color?: 'primary' | 'white' | 'gray' | 'success' | 'warning' | 'danger';
  variant?: 'spinner' | 'dots' | 'pulse';
}

const sizeClasses = {
  xs: 'h-3 w-3',
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
  xl: 'h-12 w-12',
};

const colorClasses = {
  primary: 'text-primary',
  white: 'text-white',
  gray: 'text-muted-foreground',
  success: 'text-success',
    warning: 'text-warning',
  danger: 'text-destructive',
};

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  className,
  color = 'primary',
  variant = 'spinner',
}) => {
  if (variant === 'dots') {
    return (
      <div className={clsx('flex items-center justify-center space-x-1', className)}>
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className={clsx(
              'rounded-full animate-pulse',
              sizeClasses[size].replace('h-', 'h-').replace('w-', 'w-').split(' ')[0],
              sizeClasses[size].replace('h-', 'h-').replace('w-', 'w-').split(' ')[1],
              colorClasses[color].replace('text-', 'bg-')
            )}
            style={{
              animationDelay: `${i * 0.2}s`,
              animationDuration: '1.4s'
            }}
          />
        ))}
      </div>
    );
  }

  if (variant === 'pulse') {
    return (
      <div className={clsx('flex items-center justify-center', className)}>
        <div
          className={clsx(
            'rounded-full animate-ping',
            sizeClasses[size],
            colorClasses[color].replace('text-', 'bg-'),
            'opacity-75'
          )}
        />
      </div>
    );
  }

  return (
    <div className={clsx('flex items-center justify-center', className)}>
      <svg
        className={clsx(
          'animate-spin transition-all duration-200 ease-in-out',
          sizeClasses[size],
          colorClasses[color]
        )}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
    </div>
  );
};

export default LoadingSpinner;